import React from 'react';
import { PropTypes} from 'prop-types';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 9,
    maxWidth: 300
  },
}));

function Bus(props) {

    return (
        <div className="flex">
          <img className='w-[15px] h-[17px]' alt='Metro Bus' src='./icons/bus.png' />
          <div className='flex flex-wrap'>
            {
              props.stops && props.stops.map((item, i) => {
                      return (
                          <LightTooltip key={i} placement="top"  title={item === 'DCCirc.'? 'DCCirculator':  item}>
                              <span  
                                  className="ml-[8px] text-[9px]">{item}
                              </span>
                          </LightTooltip>
                      );
              })
            }
          </div>

        </div>
      );
} 

Bus.propTypes = {
    stops:  PropTypes.array
};

Bus.defaultProps = {
    stops:[
    ],
};

export default Bus;
